import { addMixpanelEvent } from '@/redux/reducers/sharedSlice';
import { getFileUuidFromPath } from '@/Utils/getFileUuidFromPath';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../UI/Button/Button';
import Icon from '../UI/Icon/Icon';

const TIMEOUT_DELAY = 3000;

const FormulaBuilderFeedback = ({
  setShowFormulaBuilderFeedback,
  preview,
  aiFormulaQuery,
  aiFormulaResponse,
}) => {
  const [isFeedbackSent, setIsFeedbackSent] = useState(false);
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);

  const handleClick = (feedbackValue) => {
    console.log({
      eventName: 'AI Formula Builder Feedback',
      eventProps: {
        file_uuid: getFileUuidFromPath(),
        feedbackValue,
        query: aiFormulaQuery,
        response: aiFormulaResponse,
      },
      userIncrementName: '# of feedbacks',
    });
    setIsFeedbackSent(true);
    dispatch(
      addMixpanelEvent({
        eventName: 'AI Formula Builder Feedback',
        eventProps: {
          file_uuid: getFileUuidFromPath(),
          feedbackValue,
          query: aiFormulaQuery,
          response: aiFormulaResponse,
        },
        userIncrementName: '# of feedbacks',
      })
    );

    timeoutRef.current = setTimeout(() => {
      setShowFormulaBuilderFeedback(false);
    }, TIMEOUT_DELAY);
  };

  useEffect(() => {
    setIsFeedbackSent(false);
    clearTimeout(timeoutRef.current);
  }, [preview]);

  return (
    <div className='h-10 flex items-center w-full border rounded border-capri-900 bg-capri-100 bg-opacity-80'>
      <div className='flex justify-between items-center w-full mx-2'>
        {isFeedbackSent ? (
          <div className='w-full text-center'>Thank you for your feedback!</div>
        ) : (
          <>
            <div className='flex gap-2 items-center align-middle'>
              <Icon name='info' color='#0079B6' size='20' />
              Is this the result you were looking for?
            </div>
            <div>
              <Button
                iconName='thumbs-up'
                variant='ghost'
                color='capri'
                onClick={() => handleClick('like')}
              />
              <Button
                iconName='thumbs-down'
                variant='ghost'
                color='capri'
                onClick={() => handleClick('dislike')}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FormulaBuilderFeedback;
